import { useQuery } from "@tanstack/react-query";

export type WaitlistAvailability = {
  organization: {
    name: string;
    phoneNumber: string;
    timezone: string;
    location: string;
    logoUrl: string;
  };
  appointment: {
    name: string;
    duration: number;
  };
};

type WaitlistAvailabilityParams = {
  uniqueId?: string;
  enabled: boolean;
};

export function useWaitlistAvailability({
  uniqueId,
  enabled = true
}: WaitlistAvailabilityParams) {
  return useQuery({
    queryKey: ["waitlist-availability", uniqueId],
    queryFn: async () => {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/bookings/waitlist?uniqueId=${uniqueId}`,
        {
          method: "GET"
        }
      );
      if (response.status !== 200) {
        throw new Error("Error loading availability");
      }
      return response.json();
    },
    retry: false,
    staleTime: 1000 * 60 * 5, // cache for 5 minutes
    enabled
  });
}
